$(document).ready(function () {
  if ($(".showOverlayHeader").length > 0) {
    $(".mainHeaderContainer").attr("data-enable_overlay", "true");
  }

  // move to cart code start

  $("a.header__link.moveToCart").click(function () {
    window.location.href = "/cart";
  });

  // header drawer code start
  $("button.mobileMenuOpener").click(function () {
    $("#mobile-header").toggleClass("mobileMenuOpen");
    $(".header--classic").toggleClass("mobileMenuIsOpen");
    $("html, body").toggleClass("hideScroll");
  });
  let updateCaretIcon = $(".mobileCaretIcon").html();
  $(".mobile-menu .submenu__label  .close-dropdown").html(updateCaretIcon);
  $(".mega-menu__linklist p.menu__heading").append(updateCaretIcon);

  $(".mobile-menu .mega-menu__linklist p.menu__heading").click(function () {
    $(this).toggleClass("isOpen");
    $(this).next("ul").slideToggle(600);
  });

  $(".close-dropdown").click(function () {
    $(".backMenuBtnNew").addClass("showBackBtn");
    $(".mobile-header").addClass("subeMenuIsOpen");
  });
  $(".backMenuBtnNew").click(function () {
    $(this).removeClass("showBackBtn");
    $(".submenu__input:checked").prop("checked", false);
    $(".mobile-header").removeClass("subeMenuIsOpen");
  });
  // header drawer code start

  //   footer menu mobile item collapse code start
  $("p.footer__heading").click(function () {
    $(this).children(".footerCollapseIcon").toggleClass("isOpen");
    $(this).next("ul").slideToggle(600);
  });
  //   footer menu mobile item collapse code end

  // custom tabs section start
  $(".tabTitleAndBtnContainer li").click(function () {
    $(".tabTitleAndBtnContainer li").removeClass("activeTab");
    $(this).addClass("activeTab");
    $(".tabContentBlock").hide();
    var tabContent = $(this).attr("data-id");
    $(tabContent).fadeIn(200);
    $(".tabItemsDropdownContent").removeClass("activeDropDown");
  });

  $(".mobileDropDownOpener").click(function () {
    $(this).parent(".tabItemsDropdownContent").toggleClass("activeDropDown");
  });

  $(".js-recover-password").click(function () {
    $("#loginPageHeader").hide();
    $("#resetPageHeader").show();
  });
  $(".cancel-recover-password").click(function () {
    $("#loginPageHeader").show();
    $("#resetPageHeader").hide();
  });
  // custom tabs section end

  // custom collection sorting dropdown code start
  $(".dropDownBtn").click(function () {
    $(this).parent(".filterCustomDropDown").toggleClass("activeDropDown");
  });
  $(".sortingBtn").click(function () {
    let dataVal = $(this).attr("data-val");
    $("#sort-by").val(dataVal).trigger("change");
    $(".sortingBtn").removeClass("activeSort");
    $(this).addClass("activeSort");
    $(".filterCustomDropDown").removeClass("activeDropDown");
  });

  $(".sortingBtnNew").click(function () {
    let dataVal = $(this).attr("data-val");
    let thisText = $(this).text();
    $("#sort-by").val(dataVal).trigger("change");
    $(".sortingBtnNew").removeClass("activeSort");
    $(this).addClass("activeSort");
    $(".filterCustomDropDown").removeClass("activeDropDown");

    $(this)
      .parent(".dropDownItem")
      .prev(".dropDownBtn")
      .children(".btnTxt")
      .text(thisText);
  });

  $(".tagFilterBtn").click(function () {
    let dataVal = $(this).attr("data-val");
    $("#tag_filter").val(dataVal).trigger("change");
    $(".tagFilterBtn").removeClass("activeSort");
    $(this).addClass("activeSort");
    $(".filterCustomDropDown").removeClass("activeDropDown");
  });

  // custom collection sorting dropdown end
  // product page tabs code start
  $(".tabOpeningBtn ").click(function () {
    $(this).parent(".tabMainContainer").toggleClass("activeTab");
    $(this).next(".tabContent").slideToggle(500);
  });
  // product page tabs code end

  function freeShippingCartMessage() {
    // Get the cart total price from the div's inner text
    var cartTotalText = $(".cart__subtotal__price .saw-cart-total").text();

    // Check if the cart total element exists and is not empty
    if (cartTotalText.trim() !== "") {
      // Extract the numeric value from the text (remove the "$" sign and convert to a number)
      var cartTotal = parseFloat(cartTotalText.replace("$", ""));

      // Get the minimum cart total for free shipping from the div with class "targetValue"
      var minCartTotalText = $(".targetValue").text();

      // Extract the numeric value from the "minCartTotalText" (remove the "$" sign and convert to a number)
      var minCartTotal = parseFloat(minCartTotalText.replace("$", ""));

      // Calculate the percentage
      var percentage = (cartTotal / minCartTotal) * 100;

      // Ensure the percentage doesn't exceed 100%
      percentage = Math.min(percentage, 100);

      // Set the width of the free shipping bar
      $(".fs-indicator__bar.bar").css("width", percentage + "%");

      // Display the appropriate message
      if (cartTotal >= minCartTotal) {
        $(".indicator__msg").text("You got free shipping!");
      } else {
        var remainingAmount = minCartTotal - cartTotal;
        $(".indicator__msg").text(
          "Only $" + remainingAmount.toFixed(2) + " left for free shipping."
        );
      }
    } else {
      // The cart total element is not ready yet, so you can retry after a delay
      setTimeout(freeShippingCartMessage, 1200); // Retry after 1 second
    }
  }

  function addingSVGIconOnLoad() {
    if ($(".aboutCourseInrtro2.alignItemsFlexStart p strong").length > 0) {
      const calenderIcon = `<svg fill="none" viewBox="0 0 24 24"><g fill="#69607b" fill-rule="evenodd" clip-rule="evenodd"><path d="M6 3.25A4.75 4.75 0 001.25 8v10A4.75 4.75 0 006 22.75h12A4.75 4.75 0 0022.75 18V8A4.75 4.75 0 0018 3.25H6zM7.5 9.5a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1A.5.5 0 009 11v-1a.5.5 0 00-.5-.5h-1zm3.5.5a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1zm4.5-.5a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-1zM7 13a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1A.5.5 0 017 14v-1zm.5 2.5a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1A.5.5 0 009 17v-1a.5.5 0 00-.5-.5h-1zM11 13a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1zm.5 2.5a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-1zM15 13a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1zm.5 2.5a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-1z"/><path d="M8 1.25a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0V2A.75.75 0 018 1.25zM16 1.25a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0V2a.75.75 0 01.75-.75z"/></g></svg>`;
      $(".aboutCourseInrtro2.alignItemsFlexStart p strong").prepend(
        calenderIcon
      );
    }
  }

  function showPopupOnLoad() {
    if ($(".showInPopup").length > 0) {
      setTimeout(function () {
        $("body").addClass("activeContactPopup");
      }, 1200);
      $(document).on("click", ".formPopupOpener", function () {
        $("body").addClass("activeContactPopup");
      });
      $(document).on("click", ".closePopupBtn, .popupOverlay", function () {
        $("body").removeClass("activeContactPopup");
      });
    }
  }
  // Initial call to the function
  freeShippingCartMessage();
  addingSVGIconOnLoad();
  showPopupOnLoad();
});
